import { useTranslation } from "src/design-system/core/TranslationContext";
import { COUNTRIES_TRANSLATION_NAMESPACE } from "src/i18n/config";

export enum CountryEnum {
    AU = "AU",
    AT = "AT",
    BE = "BE",
    BR = "BR",
    BG = "BG",
    CA = "CA",
    CY = "CY",
    CZ = "CZ",
    DK = "DK",
    EE = "EE",
    FI = "FI",
    FR = "FR",
    DE = "DE",
    GR = "GR",
    HK = "HK",
    HU = "HU",
    IN = "IN",
    IE = "IE",
    IT = "IT",
    JP = "JP",
    LV = "LV",
    LT = "LT",
    LU = "LU",
    MY = "MY",
    MT = "MT",
    MX = "MX",
    NL = "NL",
    NZ = "NZ",
    NO = "NO",
    PL = "PL",
    PT = "PT",
    RO = "RO",
    SG = "SG",
    SK = "SK",
    SI = "SI",
    ES = "ES",
    SE = "SE",
    CH = "CH",
    AE = "AE",
    GB = "GB",
    US = "US",
    HR = "HR",
    GI = "GI",
    ID = "ID",
    LI = "LI",
    PH = "PH",
}

//make a subset type for handled countries returned by the hook
export type HandledCountryEnum =
    | CountryEnum.GB
    | CountryEnum.FR
    | CountryEnum.BE
    | CountryEnum.ES
    | CountryEnum.IT
    | CountryEnum.CH
    | CountryEnum.NL
    | CountryEnum.IE
    | CountryEnum.PT
    | CountryEnum.LU
    | CountryEnum.AT
    | CountryEnum.DE;

export const useCountries = (onlyHandledCountries = true): Record<HandledCountryEnum, string> => {
    const { t } = useTranslation(`${COUNTRIES_TRANSLATION_NAMESPACE}:`);

    const countries: Record<CountryEnum, string> = Object.values(CountryEnum).reduce(
        (acc, countryCode) => ({ ...acc, [countryCode]: t(countryCode) }),
        {} as Record<CountryEnum, string>
    );

    if (onlyHandledCountries) {
        return {
            GB: countries[CountryEnum.GB],
            FR: countries[CountryEnum.FR],
            BE: countries[CountryEnum.BE],
            ES: countries[CountryEnum.ES],
            IT: countries[CountryEnum.IT],
            CH: countries[CountryEnum.CH],
            NL: countries[CountryEnum.NL],
            IE: countries[CountryEnum.IE],
            PT: countries[CountryEnum.PT],
            LU: countries[CountryEnum.LU],
            AT: countries[CountryEnum.AT],
            DE: countries[CountryEnum.DE],
        };
    }

    return countries;
};
